export default __webpack_public_path__ + "media/images/flags/ga-c4e6f9e83305a5b4daea4ae38a99009c.png";